import React, { useEffect, useState } from 'react';
import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import Slide from '@mui/material/Slide';
import CloseIcon from '@mui/icons-material/Close';
import { Alert } from '@mui/material';
import { useAtom } from 'jotai';
import { openSnackbarAdviseAtom } from '../Atoms';

const SnackbarAdvise = function SnackbarAdvise() {
  const [open, setOpen] = useAtom(openSnackbarAdviseAtom);
  const [options, setOptions] = useState({
    severity: 'info',
    message: ' ',
  });

  useEffect(() => {
    if (open) {
      setOptions({
        severity: open?.severity,
        message: open?.message,
      });
    }
  }, [open]);

  const onClose = () => {
    setOpen(null);
  };

  const CloseButton = (
    <IconButton
      size="small"
      aria-label="close"
      color="inherit"
      onClick={onClose}
    >
      <CloseIcon fontSize="small" />
    </IconButton>
  );

  return (
    <Snackbar
      open={Boolean(open)}
      onClose={onClose}
      TransitionComponent={Slide}
      message={options?.severity === 'info' && options?.message}
      action={CloseButton}
      autoHideDuration={!open?.manualClosing ? 6000 : null}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert
        onClose={onClose}
        variant="filled"
        severity={options?.severity}
        data-testid="snackbar-advise"
        sx={{ width: '100%', color: 'white.main' }}
      >
        {options?.message}
      </Alert>
    </Snackbar>
  );
};

export default SnackbarAdvise;
